/* eslint-disable global-require, class-methods-use-this */
// Libs / Helpers
import React, { Component } from 'react';

import FormGroupControl from 'Components/forms/form-group-control/FormGroupControl';
import './ManualTransaction.scss';
import moment from 'moment';

export class ManualTransaction extends Component {
  constructor(props) {
    super(props);

    this.attachBindings();
  }

  componentWillMount() {}

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  resetScrollPos() {
    this.state.scrollPos = 0;
  }

  attachBindings() {
    this.setDefaultValues = this.setDefaultValues.bind(this);
  }
  setDefaultValues() {
    const defValue = this.props.caseData;
    const transactionDetailObject = {};
    transactionDetailObject.transactionDate = moment(defValue.transactionDate);
    transactionDetailObject.acqReferenceNumber = defValue.acquirerReferenceNumber;
    transactionDetailObject.globalToken = defValue.globalToken;
    transactionDetailObject.transactionAmount =
      defValue.transactionAmount.value == undefined ? defValue.transactionAmount : defValue.transactionAmount.value;
    transactionDetailObject.isRequiredMissing = false;
    return transactionDetailObject;
  }

  render() {
    return (
      <div>
        {this.props.showErrorBanner}
        <section className="case-landing-container">
          <FormGroupControl
            primaryActionButtonText={this.props.structureMetaData.primaryActionButtonText}
            onClickCancelButton={this.props.onClickCancelButton}
            onClickPrimaryActionButton={this.props.onClickPrimaryActionButton}
            columns={this.props.structureMetaData.dataColumns}
            formTitle={this.props.structureMetaData.title}
            formWidth={this.props.structureMetaData.formWidth}
            wrapperWidth={this.props.structureMetaData.wrapperWidth}
            inputBoxWidth={this.props.structureMetaData.inputBoxWidth}
            setDefaultValues={this.setDefaultValues}
            dropDownMandatoryField = {(this.props.caseData.acquirerName === 'EMD') ? true : false}
          />
        </section>
      </div>
    );
  }
}

export default ManualTransaction;
/* eslint-enable global-require, class-methods-use-this */
